const keywords = ["在线", "未删减", "禁忌", "人性", "尺度", "大尺度"];

const stats = [
  { value: "6 大", label: "题材细分方向" },
  { value: "10 部", label: "代表作品赏析" },
  { value: "5 档", label: "分级尺度说明" },
];

export default function Hero() {
  return (
    <section id="top" className="relative w-full h-[600px] md:h-[720px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20an%20atmospheric%20dim%20vintage%20cinema%20hall%20with%20rows%20of%20empty%20red%20velvet%20seats%20facing%20a%20softly%20glowing%20blank%20screen%2C%20warm%20low%20light%2C%20dust%20motes%20in%20a%20light%20beam%2C%20moody%20elegant%20atmosphere%2C%20shallow%20depth%20of%20field&width=1920&height=1080&seq=hero-cinema-hall&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/65"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/20 to-transparent"></div>
      </div>

      <div className="relative z-10 w-full max-w-6xl mx-auto px-4 md:px-6 pt-20">
        <div className="flex items-center gap-3 animate-fade-up">
          <span className="h-px w-8 bg-accent-400" />
          <span className="font-label text-xs md:text-sm tracking-[0.3em] text-accent-300 uppercase">
            内容专题 · 电影赏析
          </span>
        </div>

        <h1 className="mt-5 font-heading text-3xl md:text-5xl lg:text-[3.4rem] font-bold text-background-50 leading-tight max-w-3xl animate-fade-up">
          欧美伦理电影
          <span className="block mt-2 text-2xl md:text-3xl lg:text-4xl font-semibold text-background-50/90">
            在线、未删减与人性尺度的一份内容总览
          </span>
        </h1>

        <p className="mt-6 text-sm md:text-lg text-background-50/85 leading-relaxed max-w-2xl animate-fade-up-delay-1">
          这里不提供片单拼凑，而是把「欧美伦理电影」拆成可以逐个理解的方向：它到底在拍什么、题材如何细分、
          尺度与分级意味着什么、未删减版差在哪里，以及人性母题如何被一层层讲出来。
        </p>

        <div className="mt-7 flex flex-wrap gap-2 animate-fade-up-delay-1">
          {keywords.map((k) => (
            <span
              key={k}
              className="px-3 py-1.5 rounded-full border border-background-50/30 bg-background-50/10 text-background-50/90 font-label text-xs md:text-sm backdrop-blur-sm"
            >
              {k}
            </span>
          ))}
        </div>

        <div className="mt-9 flex flex-col sm:flex-row gap-3 animate-fade-up-delay-2">
          <a
            href="#intro"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 font-label text-sm md:text-base whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
          >
            先了解它是什么
            <i className="ri-arrow-down-line text-lg"></i>
          </a>
          <a
            href="#works"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-50/10 border border-background-50/35 text-background-50 font-label text-sm md:text-base whitespace-nowrap hover:bg-background-50/20 transition-colors cursor-pointer"
          >
            查看代表作品
            <i className="ri-film-line text-lg"></i>
          </a>
        </div>

        <div className="mt-12 grid grid-cols-3 gap-4 max-w-xl border-t border-background-50/20 pt-6 animate-fade-up-delay-3">
          {stats.map((s) => (
            <div key={s.label}>
              <div className="font-heading text-xl md:text-3xl font-bold text-accent-300">{s.value}</div>
              <div className="mt-1 font-label text-[11px] md:text-xs text-background-50/70">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}